/*
 * Copy-to-clipboard for the offer card's gift code (variant A).
 *
 * Delegated from the document so it survives the collection grid being
 * re-rendered by filters, sorting and load-more.
 */
(function () {
  if (window.__offerCardCopy) return;
  window.__offerCardCopy = true;

  var RESET_MS = 2400;

  function flash(button, text) {
    var label = button.querySelector('[data-offer-code-label]');
    if (!label) return;
    if (!button.dataset.idleLabel) button.dataset.idleLabel = label.textContent;
    label.textContent = text;
    button.classList.add('is-copied');
    clearTimeout(button.__resetTimer);
    button.__resetTimer = setTimeout(function () {
      label.textContent = button.dataset.idleLabel;
      button.classList.remove('is-copied');
    }, RESET_MS);
  }

  // navigator.clipboard is unavailable on insecure origins and in some
  // in-app browsers, which is exactly where this card gets seen.
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.cssText = 'position:fixed;top:-1000px;opacity:0;';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      area.remove();
      ok ? resolve() : reject();
    });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-offer-code]');
    if (!button) return;
    var code = button.getAttribute('data-offer-code');
    if (!code) return;
    e.preventDefault();
    copy(code).then(
      function () {
        flash(button, 'Copied');
      },
      function () {
        // Nothing was copied, so say so rather than claiming success.
        flash(button, code);
      }
    );
  });
})();
